import request from '@/utils/request'

// 查询店铺等级分页
export function pageShopLevel(query) {
  return request({
    url: '/shop/shop/level/page',
    method: 'get',
    params: query
  })
}

// 查询店铺等级列表
export function listShopLevel(query) {
  return request({
    url: '/shop/shop/level/list',
    method: 'get',
    params: query
  })
}

// 查询店铺等级详情
export function getShopLevel(data) {
  return request({
    url: '/shop/shop/level/detail',
    method: 'get',
    params: data
  })
}

// 新增店铺等级
export function addShopLevel(data) {
  return request({
    url: '/shop/shop/level/add',
    method: 'post',
    data: data
  })
}

// 修改店铺等级
export function updateShopLevel(data) {
  return request({
    url: '/shop/shop/level/edit',
    method: 'post',
    data: data
  })
}

// 删除店铺等级
export function delShopLevel(data) {
  return request({
    url: '/shop/shop/level/delete',
    method: 'post',
    data: data
  })
}
